export const DATA_API = 'resizableColumns';
export const DATA_NO_RESIZE = 'noresize';
export const DATA_COLUMNS_ID = 'resizable-columns-id';
export const DATA_COLUMN_ID = 'resizable-column-id';
export const DATA_TH = 'th';

export const CLASS_TABLE_RESIZING = 'rc-table-resizing';
export const CLASS_COLUMN_RESIZING = 'rc-column-resizing';
export const CLASS_HANDLE = 'rc-handle';
export const CLASS_HANDLE_CONTAINER = 'rc-handle-container';

export const EVENT_RESIZE_START = 'column:resize:start';
export const EVENT_RESIZE = 'column:resize';
export const EVENT_RESIZE_STOP = 'column:resize:stop';

export const SELECTOR_TH = 'tr:first > th:visible';
export const SELECTOR_TD = 'tr:first > td:visible';
